export const RESPONSE = {
  NUMBER_REQUIRED: 'Registration number is required',
  DATA_NOT_FOUND: 'Data not found',
  INTERNAL_ERROR: 'Internal Server Error',
  SERVICE_ERROR: 'Service Error:',
  FAILED_VEHICLE_DATA: 'Failed to fetch vehicle data',
  ERROR_AUTO_API: 'Error fetching from AUTO_API:',
  ERROR_PUC_API: 'Error fetching PUC Api',
  UNAUTHORIZED_REQUEST: 'Unauthorized. Please log in.',
  REGISTRATION_NUMBER_REQUIRED: 'Registration number and phone number are required',
  ASSET_ADDITION_ERROR: 'Error in assetAdditionService API',
  ASSET_VEHICLE_ERROR: 'Error in assetVehicleService API',
  ASSET_SERVICE_CONFIGURATION: 'Asset service configuration not found',
  VEHICLE_NOT_FOUND: 'Vehicle info service configuration not found',
  VARIANT_DETAIL_FAIL: 'Failed to fetch variant details.',
  GET_VARIANT_DETAIL_ERROR: 'Error in getVariantDetails API:',
  USER_ID_REQUIRED: 'User ID is required',
  VARIANT_ID_ERROR: 'variant_id is required and must be a single value',
  ERROR_HTTP: 'HTTP error! Status:',
  CHALLAN_SERVICE_ERROR: 'Challan Service Error',
  CHALLAN_FETCH_FAIL: 'Failed to fetch challans',
  ABORT_ERROR: (timeout) => `Request timed out after ${timeout}ms`
}
